import {
  CommodityCataloguesApi,
  CreateCommodityCatalogueCommand,
  UpdateCommodityCatalogueCommand,
} from '@billing/app/api'
import { createApiClient } from '@billing/app/http-client'

class CommodityCatalogueService {
  httpClient = createApiClient(CommodityCataloguesApi)

  async getCatalogues() {
    const { data } = await this.httpClient.get()
    return data
  }

  async createCatalogue(catalogue: CreateCommodityCatalogueCommand) {
    const { data } = await this.httpClient.create(catalogue)
    return data
  }
  async updateCatalogue(catalogue: UpdateCommodityCatalogueCommand) {
    const { data } = await this.httpClient.update(catalogue)
    return data
  }

  async deleteCatalogue(id: number) {
    await this.httpClient._delete(id)
  }
}

const commodityCatalogueService = new CommodityCatalogueService()

export default commodityCatalogueService
